import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, DatePicker, Empty, Spin, Popover, Badge } from 'antd';

import { RatingChart } from './components/RatingChart';
import { Container, FeedbackCard, Main } from './styles';
import { ModuleHeader } from '~/components/ModuleHeader';
import { FeedbacksModal } from './components/FeedbacksModal';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import {
  getFeedbacksRange,
  getFeedbacksPeriodFromRange,
  getFeedbacksPeriodLabel,
  isFeedbacksPeriodDefault,
  countActiveFeedbacksFilters,
} from './helpers';

const { RangePicker } = DatePicker;

export const Feedbacks = ({ persisted }) => {
  const { feedbacks, isLoading } = useSelector((state) => ({
    feedbacks: state.feedbacks.list,
    isLoading: state.feedbacks.isLoading,
  }));

  // The applied period ('YYYY-MM-DD' strings) lives in the screen
  // (usePersistedFilters), which reloads the KPIs whenever it changes. The
  // defaults are computed at mount, so "is default" follows the current month.
  const applied = persisted.filters;
  const defaults = persisted.defaults;
  const dateRange = getFeedbacksRange(applied);
  const isPeriodDefault = isFeedbacksPeriodDefault(applied, defaults);
  const periodLabel = getFeedbacksPeriodLabel(applied);
  const clearFilters = () => persisted.resetFilters();

  const [feedbacksModal, setFeedbacksModal] = useState({
    isVisible: false,
  });

  function closeFeedbacksModal() {
    setFeedbacksModal({ isVisible: false });
  }

  function openFeedbacksModal() {
    setFeedbacksModal({ isVisible: true });
  }

  return (
    <Container>
      <ModuleHeader
          breadcrumbs={['Relatórios', 'KPIs']}
          title="KPIs"
          center={
            <Popover
              trigger="click"
              placement="bottomRight"
              content={
                <div style={{ width: 320 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                    {!persisted.isDefault && (
                      <a
                        style={{ fontSize: 12, color: '#f5222d' }}
                        onClick={clearFilters}
                      >
                        Limpar
                      </a>
                    )}
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4, display: 'block' }}>Período</span>
                    <RangePicker
                      format="DD/MM/YYYY"
                      value={dateRange}
                      onChange={function(dates) {
                        var period = getFeedbacksPeriodFromRange(dates);
                        if (period) persisted.setFilters(period);
                      }}
                      allowClear={false}
                      style={{ width: '100%' }}
                    />
                  </div>
                </div>
              }
            >
              <Badge
                count={countActiveFeedbacksFilters(applied, defaults)}
                offset={[-4, 0]}
                style={{ backgroundColor: '#722ed1' }}
              >
                <Button icon="bars" style={{ borderRadius: 8 }}>Filtros</Button>
              </Badge>
            </Popover>
          }
          advanced={
            (function() {
              var pills = [];
              pills.push({
                key: 'dateRange',
                label: periodLabel,
                color: isPeriodDefault ? '#1890ff' : '#722ed1',
                icon: 'calendar',
                onRemove: isPeriodDefault ? undefined : function() { persisted.setFilters({ from: defaults.from, to: defaults.to }); },
              });
              return React.createElement(FilterPillsBar, {
                pills: pills,
                onClearAll: persisted.isDefault ? undefined : clearFilters,
              });
            })()
          }
      />
      <RestoredFiltersNotice
        visible={persisted.wasRestored}
        summary={periodLabel}
        onReset={clearFilters}
        onDismiss={persisted.dismissRestored}
      />
      <Main>
        <FeedbackCard
          title="Área do cliente"
          extra={
            <Button type="primary" size="small" onClick={openFeedbacksModal}>
              Detalhes
            </Button>
          }
        >
          {isLoading ? <Spin /> : <RatingChart feedbacks={feedbacks} />}
          {!isLoading && feedbacks.length === 0 && (
            <Empty
              description="Não existem feedbacks neste período."
            />
          )}
        </FeedbackCard>
      </Main>
      <FeedbacksModal
        isVisible={feedbacksModal.isVisible}
        onClose={closeFeedbacksModal}
        feedbacks={feedbacks}
      />
    </Container>
  );
};
